// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"42":"reactPlayerTwitch","85":"reactPlayerTiktok","173":"reactPlayerVimeo","262":"reactPlayerHls","340":"reactPlayerWistia","353":"reactPlayerPreview","395":"reactPlayerDash","446":"reactPlayerYouTube","723":"reactPlayerMux","771":"reactPlayerSpotify"}[chunkId] || chunkId) + ".chunk.js";
};